import { ApolloError, ApolloQueryResult, DocumentNode } from '@apollo/client';
import { GraphQLCampaign } from 'modules/campaigns/lib/types';
import { CampaignId } from 'modules/domains/campaign';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { queryCampaignById } from '../queries';

export type QueryCampaignByIdRequest = {
  id: CampaignId;
};

export type QueryCampaignByIdResponse = {
  campaign: GraphQLCampaign;
};

export type UseQueryCampaignByIdResponse = {
  errorMessage?: ApolloError;
  hasError: boolean;
  isLoading: boolean;
  refetch: (
    variables?: QueryCampaignByIdRequest,
  ) => Promise<ApolloQueryResult<QueryCampaignByIdResponse>>;
  results: GraphQLCampaign;
};

export const useQueryCampaignById = (
  options: Record<string, any> = {},
  query: DocumentNode = queryCampaignById,
): UseQueryCampaignByIdResponse => {
  const queryOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      ...options,
    }),
    [options],
  );

  const {
    data,
    errorMessage,
    isLoading,
    error: hasError = false,
    refetch,
  } = useGraphql(query, queryOptions);

  const results = data?.campaign ?? {};

  return {
    errorMessage,
    hasError,
    isLoading,
    refetch,
    results,
  };
};
